import { render, staticRenderFns } from "./DataText.vue?vue&type=template&id=83a2f74a&"
import script from "./DataText.vue?vue&type=script&lang=js&"
export * from "./DataText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\jenkinsworkspace\\Aigo.B2CAdmin.Publish\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('83a2f74a')) {
      api.createRecord('83a2f74a', component.options)
    } else {
      api.reload('83a2f74a', component.options)
    }
    module.hot.accept("./DataText.vue?vue&type=template&id=83a2f74a&", function () {
      api.rerender('83a2f74a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/DataText.vue"
export default component.exports